import React from 'react';
import { HOW_IT_WORKS } from '../mock';
import { ClipboardList, Truck, PackageCheck, ArrowRight } from 'lucide-react';

const ICONS = [ClipboardList, Truck, PackageCheck];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section bg-[#F7F9FC]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-12">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.25em] gold-text">How it works</span>
            <h2 className="mt-3 text-4xl md:text-5xl font-extrabold navy-text leading-tight">
              Three steps. Zero surprises.
            </h2>
          </div>
          <p className="text-lg text-[#4A5A72]">
            From the moment you request a quote to the minute your car arrives at its destination, we keep you informed, on schedule and in control.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {HOW_IT_WORKS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div key={i} className="card-lift relative bg-white border border-[#E5EAF2] rounded-2xl p-7">
                <div className="flex items-center justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-[#0A1628] flex items-center justify-center">
                    <Icon className="w-6 h-6 text-[#D4A24C]" />
                  </div>
                  <span className="text-5xl font-extrabold text-[#E5EAF2]">{s.step}</span>
                </div>
                <h3 className="text-xl font-extrabold navy-text mb-2">{s.title}</h3>
                <p className="text-sm text-[#4A5A72] leading-relaxed">{s.copy}</p>
                {i < HOW_IT_WORKS.length - 1 && (
                  <ArrowRight className="hidden md:block absolute -right-3.5 top-1/2 -translate-y-1/2 w-7 h-7 text-[#D4A24C] bg-[#F7F9FC] z-10" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
